<app-header [selectedMenu]="MENU_PAGE.PROPER_WORDING"></app-header>

<div class="container">

  <div class="wrapper">



  </div>


  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>

</div>
<app-back-btn></app-back-btn>
